import { StateUtils } from '@spartacus/core';
import { SearchPageResultState } from '../../../../core/features/store/base-feature-state';
import { SoldToSearchResult } from '../../../../core/model';
import { SoldToActions } from '../actions';
import { AvailableSoldToActionTypes } from '../actions/sold-to-available.action';

export const initialState: SearchPageResultState = {
  lastUpdateTime: undefined,
  results: [],
};

export function reducer(state = initialState, action: SoldToActions.AvailableSoldTosActions | StateUtils.LoaderAction): any {
  switch (action.type) {
    case AvailableSoldToActionTypes.LoadAvailableSoldTosSuccess:
    case AvailableSoldToActionTypes.LoadAvailableSoldTosOnUserDetailsSuccess: {
      const payload: SoldToSearchResult = action.payload;

      const results = payload.results.map((r) => r.uid);

      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
        results,
      };
    }
    default: {
      return state;
    }
  }
}
